import { merge } from "lodash";

import errors from "./common";

export default merge(errors, {});
